import { UAParser } from 'ua-parser-js';

export function uaParserFilter () {
	const parser = new UAParser();
	return (uaString) => {
		parser.setUA(uaString);
		return parser.getResult();
	};
}
